module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-bright-red-up.d65be0df.svg";